import React from "react";

import { formatNumber } from "utils";

import { Col, PayoutInVerificationCard, Row } from "components";

export const PayoutHistory = ({ payouts, userModules }) => {
  const years = [...new Set(payouts.map(({ year }) => year))].sort((a, b) => b - a);
  const sortedData = {};

  for (const payoutYear of years) {
    sortedData[payoutYear] = payouts.filter(({ year }) => year === payoutYear);
  }

  return (
    <>
      {years.map((year, i) => (
        <Row key={i}>
          <Col>
            <h3 className="margin-top-200">{year}</h3>
          </Col>
          {sortedData[year].map(({ payout, approvedCredits, rejectedCredits, approved, payoutAtVerificationStart }, i) => (
            <Col key={i} md={12} sm={12}>
              <PayoutInVerificationCard
                className={`payout-history-card ${approved ? "approved" : "rejected"}`}
                // PayoutInVerificationCard component takes a range, because it needs to support range or no range
                // In PayoutHistory we for sure will only have 1 accurate value
                payout={{ min: payout, max: payout }}
                preVerificationPayout={rejectedCredits ? (approvedCredits + rejectedCredits) * (payout / approvedCredits) : null}
                payoutAtVerificationStart={payoutAtVerificationStart}
                status={approved ? "approved" : "rejected"}
                modules={userModules}
                year={+year}
              >
                <div className="payout-card-credits">
                  <span className="paragraph-m">total carbon credits</span>
                  <div>
                    {rejectedCredits ? <span className="rejected">{formatNumber({ number: approvedCredits + rejectedCredits })}</span> : null}
                    {approved && <span className="paragraph-m-bold">{formatNumber({ number: approvedCredits })}</span>}
                  </div>
                </div>
              </PayoutInVerificationCard>
            </Col>
          ))}
        </Row>
      ))}
    </>
  );
};
